import Glide, {
  Controls,
  Breakpoints,
  Swipe,
} from '@glidejs/glide/dist/glide.modular.esm';

const homepageSliderObject = new Glide('[data-homepage-slider]', {
  perView: 1,
  gap: 0,
  type: 'carousel',
});
homepageSliderObject.mount({ Controls, Breakpoints, Swipe });
